<template>
    <div class="success-checkmark" v-if="ready">
        <div class="check-icon">
            <span class="icon-line line-tip"></span>
            <span class="icon-line line-long"></span>
            <div class="icon-circle"></div>
            <div class="icon-fix"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: "SuccessAnimation",
    props: {
        delay: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        setTimeout(() => this.ready = true, this.delay);
    }
}
</script>

<style>
</style>